import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../../../../../../Translations';
import CelebrateImage from '../../../../../Cutesies/CelebrateImage';
import LearningCollectionEditStore from '../../../Edit/Store';

interface Props {
  store: LearningCollectionEditStore;
}

const Celebration: React.FC<Props> = ({ store }) => {
  return (
    <div
      className={clsx(
        'bg-chevron bg-cover bg-fixed',
        'min-h-screen w-screen bg-center pt-24',
        'bg-chevron bg-no-repeat flex flex-col items-start h-screen',
      )}
    >
      <div className="mx-auto">
        <CelebrateImage />
      </div>
      <div className="my-6 text-center mx-auto w-4/5 lg:w-3/5">
        <h1 className={'my-6 text-3xl font-medium'}>
          <T kind="Nice work! Your collection is ready." />
        </h1>
        <p className="text-sm">
          <T kind="Visit the Learning Collections page to edit, preview, and share your collection. After launching, you’ll be able to see more insights into how your collection is performing." />
        </p>
        <Link
          to="/learning_collections/"
          className={clsx(
            'inline-block cursor-pointer whitespace-nowrap text-center',
            'rounded-md border-solid border-transparent mt-6 p-3 tracking-wide',
            'bg-green-600 text-lg text-white font-medium hover:bg-green-700',
          )}
        >
          <T kind="Go to my Learning Collections" />
        </Link>
      </div>
    </div>
  );
};

export default observer(Celebration);
